import React, { useState } from 'react';
import './App.css';
import ColorChangingSquare from './components/ColorChangingSquare';
import NumberDisplay from './components/NumberDisplay';
import LetterDisplay from './components/LetterDisplay';

const speedOptions = [
  { label: 'Slow', value: 12000 },
  { label: 'Normal', value: 8000 },
  { label: 'Fast', value: 3000 },
];

function App() {
  const [activeComponent, setActiveComponent] = useState('colorSquare');
  const [speed, setSpeed] = useState(8000);
  const [audioEnabled, setAudioEnabled] = useState(false);

  return (
    <div className="App">
      <nav className="bg-gray-800 p-4">
        <ul className="flex justify-center items-center">
          <li className="mx-4">
            <button
              className={`px-3 py-2 rounded text-white ${activeComponent === 'colorSquare' ? 'bg-blue-500' : 'bg-gray-700'}`}
              onClick={() => setActiveComponent('colorSquare')}
            >
              Colors
            </button>
          </li>
          <li>
            <button
              className={`px-3 py-2 rounded text-white ${activeComponent === 'numberDisplay' ? 'bg-blue-500' : 'bg-gray-700'}`}
              onClick={() => setActiveComponent('numberDisplay')}
            >
              Numbers
            </button>
          </li>
          <li>
            <button
              className={`px-3 py-2 rounded text-white ${activeComponent === 'letterDisplay' ? 'bg-blue-500' : 'bg-gray-700'}`}
              onClick={() => setActiveComponent('letterDisplay')}
            >
              Letters
            </button>
          </li>
          <li className="mx-4 flex items-center gap-1">
            <span className="text-gray-400 text-sm mr-1">Speed:</span>
            {speedOptions.map((opt) => (
              <button
                key={opt.value}
                className={`px-2 py-1 rounded text-sm text-white ${speed === opt.value ? 'bg-green-500' : 'bg-gray-700'}`}
                onClick={() => setSpeed(opt.value)}
              >
                {opt.label}
              </button>
            ))}
          </li>
          <li>
            <button
              className={`px-3 py-2 rounded text-white ${audioEnabled ? 'bg-green-500' : 'bg-gray-700'}`}
              onClick={() => setAudioEnabled(!audioEnabled)}
            >
              Sound: {audioEnabled ? 'On' : 'Off'}
            </button>
          </li>
        </ul>
      </nav>

      <div className="content mt-10">
        {activeComponent === 'colorSquare' && <ColorChangingSquare speed={speed} audioEnabled={audioEnabled} />}
        {activeComponent === 'numberDisplay' && <NumberDisplay speed={speed} audioEnabled={audioEnabled} />}
        {activeComponent === 'letterDisplay' && <LetterDisplay speed={speed} audioEnabled={audioEnabled} />}
      </div>
    </div>
  );
}

export default App;
